import type { FC } from "react";
import { routes } from "../../../routes";
import { AlertMessageConditions, type AlertMessageContext } from "../types";
import { AlertMessageLink } from "../../../../components/AlertMessage/AlertMessageLink";
import { hasGlobalSession } from "../../../../helpers/loginHelpers";
import type { AlertMessageLinkWrapperProps } from "./types";
import { useAppContext } from "../../../../helpers/context-hooks/useAppContext";

export const DefaultNoSavedDrugsLink: FC<
  AlertMessageLinkWrapperProps & {
    alertMessageContext: AlertMessageContext | undefined;
  }
> = ({ children, alertMessageContext, ...props }) => (
  <AlertMessageLink
    {...props}
    to={{
      pathname: routes.managePrescriptions,
      state: alertMessageContext?.routerState,
    }}
    condition={AlertMessageConditions.NO_SAVED_DRUGS}
  >
    {children}
  </AlertMessageLink>
);

export const NoSavedDrugsLink: FC<
  AlertMessageLinkWrapperProps & {
    alertMessageContext: AlertMessageContext;
  }
> = ({ children, alertMessageContext, ...props }) => {
  const { state } = useAppContext();
  const isLoggedIn = hasGlobalSession(state);
  const prescriptionsLink = isLoggedIn
    ? routes.summary.managePrescriptions
    : routes.managePrescriptions;
  return (
    <AlertMessageLink
      {...props}
      condition={AlertMessageConditions.NO_SAVED_DRUGS}
      to={{
        pathname: prescriptionsLink,
        search: alertMessageContext?.search,
        state: alertMessageContext?.routerState,
      }}
    >
      {children}
    </AlertMessageLink>
  );
};
